export const Challenges = {
  0: {description: 35, correctAnswer: ['5*7', '7*5']},
  1: {description: 20, correctAnswer: ['4*5', '5*4', '10*2','2*10']},
  2: {description: 24, correctAnswer: ['3*8', '8*3', '4*6','6*4', '12*2', '2*12']},
  3: {description: 36, correctAnswer: ['2*18', '18*2', '4*9','9*4', '6*6', '3*12', '12*3']},
  4: {description: 18, correctAnswer: ['2*9', '9*2', '6*3','3*6']},
  5: {description: 81, correctAnswer: ['9*9', '3*27', '27*3']},
  6: {description: 42, correctAnswer: ['2*21', '21*2', '3*14','14*3', '6*7', '7*6']},
  7: {description: 121, correctAnswer: ['11*11']},
  8: {description: 28, correctAnswer: ['2*14', '14*2', '4*7','7*4']},
  9: {description: 66, correctAnswer: ['2*33', '33*2', '3*22','22*3', '6*11', '11*6']}
};
